import React from 'react'
import socialData from '../../data/social.json'

export default function SocialIcons({ className = "", showEmoji = true }) {
  return (
    <div className={`flex space-x-4 ${className}`}>
      {showEmoji && <span className="space-x-4">👋</span>}
      {socialData.map((item) => (
        <a
          key={item.name}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          className="relative group text-slate-500 hover:text-slate-400 focus:outline-none focus:text-slate-400"
          aria-label={item.name}
        >
          <svg
            fill="currentColor"
            viewBox={item.viewBox}
            className="h-6 w-6"
            aria-hidden="true"
          >
            <path
              fillRule={item.name === 'Instagram' || item.name === 'GitHub' ? 'evenodd' : undefined}
              clipRule={item.name === 'Instagram' || item.name === 'GitHub' ? 'evenodd' : undefined}
              d={item.iconPath}
            />
          </svg>
          <span
            role="tooltip"
            className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs font-medium text-white bg-gray-900 rounded whitespace-nowrap opacity-0 invisible group-hover:opacity-100 group-hover:visible group-focus:opacity-100 group-focus:visible transition-opacity duration-200 pointer-events-none"
          >
            {item.name}
          </span>
        </a>
      ))}
    </div>
  )
}

// Export the social data for potential use elsewhere
export { socialData }
